/** @jsx jsx */
import { jsx } from "theme-ui"

import { vwoService } from "@trueskin-web/services"

import plusSvg from "./plusIcon.svg"

export const plusIcon = vwoService.isThemeRebrandedEnabled()
  ? plusSvg
  : {
      path: (
        <path
          d="M12 3v18M3 12h18"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      ),
    }
